import { defineStore } from 'pinia'
import storage from '@/utils/storage'

export const useAddressStore = defineStore('bestdealer-address', () => {
  const cacheAddress = ref(storage.get('addressForm'))
  const visible = ref(false)
  const addressType = ref(2) // 1-sourcing now (废弃), 2-add to cart, 3-点击我的shipping address 4-支付页edit

  const show = (type = 2) => {
    addressType.value = type
    visible.value = true
  }

  const close = () => {
    visible.value = false
  }

  const updateAddress = (form) => {
    storage.set('addressForm', form)
    cacheAddress.value = form
  }

  return {
    cacheAddress,
    visible,
    addressType,
    show,
    close,
    updateAddress
  }
})
